export const en = {
  'shell.nav.bar': 'Bar',
  'bar.title': 'Bar',
  'bar.description': 'Tap products to build the order, then charge the balance with a card tap, or take cash or card.',
  'bar.pickBranch': 'Choose the branch you are working at in the sidebar to sell.',
  'bar.emptyMenu': 'Nothing to sell yet',
  'bar.emptyMenuHint': 'Add products to the menu and mark them “Sold at the bar”.',
  'bar.all': 'All',
  'bar.order': 'Order',
  'bar.emptyOrder': 'Tap a product to add it.',
  'bar.total': 'Total',
  'bar.clear': 'Clear',
  'bar.increase': 'One more {name}',
  'bar.decrease': 'One fewer {name}',
  'bar.chargeBalance': 'Charge balance',
  'bar.cash': 'Cash',
  'bar.card': 'Card',
  'bar.tapTitle': 'Charge {amount} to the balance',
  'bar.tapHint': 'Ask the member to tap their card on the reader, or type the card number.',
  'bar.cardNumber': 'Card number',
  'bar.findCard': 'Find',
  'bar.cardUnknown': 'This card is not assigned to a member.',
  'bar.balanceNow': 'Balance {amount}',
  'bar.afterSale': 'After this sale: {amount}',
  'bar.shortBy': 'Short by {amount}. Top up at reception, or take cash or card.',
  'bar.confirmCharge': 'Charge {amount}',
  'bar.otherCard': 'Another card',
  'bar.payTitle': 'Take {amount} by {method}',
  'bar.payHint': 'Take the money first, then confirm. A member card tap is optional: it puts the sale in their history.',
  'bar.confirmPaid': 'Paid',
  'bar.sold': 'Sold · {receipt}',
  'bar.soldBalance': 'Sold · {receipt} · balance now {amount}',
  'bar.priceChanged': 'A price changed; the order was updated. Check the total and try again.',
  'bar.todaySales': 'Today’s sales',
  'bar.noSales': 'No sales yet today.',
  'bar.walkIn': 'Walk-in',
  'bar.saleTitle': 'Sale {receipt}',
  'bar.soldBy': 'Sold by {name}',
  'bar.qty': '{count} ×',
  'barRefund.action': 'Refund',
  'barRefund.title': 'Refund {receipt}',
  'barRefund.hint': 'Choose what goes back. It goes back as {method}, the way it was paid.',
  'barRefund.tapHint': 'Ask the member who paid to tap their card again; the money goes back onto their balance.',
  'barRefund.back': 'Back',
  'barRefund.confirm': 'Refund {amount}',
  'barRefund.reason': 'Reason',
  'barRefund.left.one': '{count} left to refund, {amount} each',
  'barRefund.left.other': '{count} left to refund, {amount} each',
  'barRefund.allBack': 'Already refunded',
  'barRefund.mismatch': 'This card is not the one of the member who paid.',
  'barRefund.done': 'Refunded {amount}',
  'barRefund.doneBalance': 'Refunded {amount} to the balance, now {balance}',
  'barRefund.lineBack': '{count} refunded',
  'barRefund.history': 'Refunds',
  'shell.nav.barStock': 'Stock',
  'shell.nav.barInsights': 'Insights',
  'menuBar.leadTime': 'Lead time, days',
  'menuBar.leadTimeHint': 'From ordering to the delivery arriving. Bar → Insights suggests an order only for items that have one.',
  'menuBar.packSize': 'Pack size',
  'menuBar.packSizeHint': 'Units per case; a suggested order is rounded up to whole cases.',
  'barInsights.title': 'Bar insights',
  'barInsights.description': 'Which items bring the money, which sit on the shelf, when the bar is busy, when shelves ran empty, and what to order.',
  'barInsights.slowLine': 'Slow after',
  'barInsights.slowAfter': 'Slow after {days} days',
  'barInsights.gradeA': 'A items',
  'barInsights.gradeAHint': 'Of {count} items sold',
  'barInsights.slowStock': 'Slow items on the shelf',
  'barInsights.stockoutDays': 'Days a shelf was empty',
  'barInsights.lostSales': 'About {amount} not sold',
  'barInsights.toOrder': 'Items to order',
  'barInsights.toOrderHint': 'With a lead time and not enough on the shelf',
  'barInsights.abc': 'ABC by revenue',
  'barInsights.abcHint': 'A: the items bringing the first 80% of revenue, B: the next 15%, C: the rest. Each row shows the running share.',
  'barInsights.aging': 'Days since the last sale',
  'barInsights.agingHint': 'Every item on the menu; slow is more than {days} days without a sale.',
  'barInsights.bucketDays': '{range} days',
  'barInsights.never': 'Never sold',
  'barInsights.daysSince': 'Days since sale',
  'barInsights.onHand': 'On hand',
  'barInsights.noSlowStock': 'No slow item has stock on the shelf.',
  'barInsights.heatmap': 'When the bar is busy',
  'barInsights.heatmapHint': 'Receipts per hour, averaged over each weekday of the period. The square with a dot is the busiest.',
  'barInsights.heat.average': 'Average for this weekday over the period',
  'barInsights.heat.busiest': 'Busiest hour',
  'barInsights.heat.receipts': 'Receipts',
  'barInsights.heat.units': 'Units',
  'barInsights.heat.takings': 'Takings',
  'barHeat.read': '{label}. Point at a square, or use the arrow keys, to read it.',
  'barHeat.less': 'Less',
  'barHeat.more': 'More',
  'barInsights.noSales': 'No sales in this period.',
  'barInsights.stockouts': 'Empty shelves',
  'barInsights.stockoutsHint': 'Days a counted item closed with nothing on the shelf, and what it usually sells on those weekdays.',
  'barInsights.stockoutLine': '{days} day(s) · about {units} units, {amount}',
  'barInsights.noStockouts': 'No counted item ran out in this period.',
  'barInsights.order': 'Suggested order',
  'barInsights.orderHint': 'Enough for the lead time and the next {days} days at the smoothed daily sales, plus safety stock, less what is on the shelf, in whole cases.',
  'barInsights.noCounted': 'No counted item sold in this period.',
  'barInsights.branch': 'Branch',
  'barInsights.perDay': 'Per day',
  'barInsights.leadTime': 'Lead time',
  'barInsights.safety': 'Safety stock',
  'barInsights.suggested': 'Order',
  'barInsights.setLeadTime': 'Set a lead time',
  'barInsights.packs': '{count} case(s) of {size}',
  'barInsights.view.items': 'Items',
  'barInsights.view.members': 'Members',
  'barMembers.intro': 'Only sales that carry a member count here: balance sales and sales where the card was tapped ({share} of bar sales in this period).',
  'barMembers.dormantLine': 'Dormant after',
  'barMembers.dormantAfter': 'Balance dormant after {days} days',
  'barMembers.penetration': 'Visitors who buy',
  'barMembers.penetrationHint': 'Member-days with a visit and a bar receipt ÷ member-days with a visit',
  'barMembers.buyingMembers': 'Members who bought',
  'barMembers.ofVisitors': 'Of {count} who came in',
  'barMembers.spendPerBuyer': 'Spend per buyer',
  'barMembers.receiptsPerBuyer': 'Receipts per buyer',
  'barMembers.byDay': 'Visitors who buy, by day',
  'barMembers.visitors': 'Came in',
  'barMembers.buyers': 'Bought',
  'barMembers.frequency': 'How often buyers buy',
  'barMembers.receipts': '{range} receipt(s)',
  'barMembers.recency': 'When buyers last bought',
  'barMembers.daysAgo': '{range} days ago',
  'barMembers.cohorts': 'Do first-time buyers come back?',
  'barMembers.cohortsHint': 'Members grouped by the month of their first bar purchase; each cell is the share buying again that many months later.',
  'barMembers.firstBought': 'First bought',
  'barMembers.noBuyers': 'No member bought at the bar yet.',
  'barMembers.byPlan': 'By plan',
  'barMembers.byAge': 'By age',
  'barMembers.byGender': 'By gender',
  'barMembers.group': 'Group',
  'barMembers.noPlan': 'No active plan',
  'barMembers.ageUnknown': 'Age not known',
  'barMembers.under18': 'Under 18',
  'barMembers.tooFew': 'No group has {size} buyers or more yet.',
  'barMembers.hidden': '{count} group(s) with fewer than {size} buyers are left out, so nobody can be picked out.',
  'barMembers.dormant': 'Balances untouched for {days} days',
  'barMembers.dormantHint': '{count} member(s) hold {amount} they have not topped up or spent. Across every branch.',
  'barMembers.noDormant': 'No dormant balance.',
  'barMembers.member': 'Member',
  'barMembers.balance': 'Balance',
  'barMembers.lastMovement': 'Last movement',
  'stock.title': 'Stock',
  'stock.description': 'What each branch has on its shelf, what it cost and how fast it sells. Sales take it down, deliveries and counts put it right.',
  'stock.empty': 'Nothing is counted yet',
  'stock.emptyHint': 'Switch on “Count stock” for an item in the menu editor.',
  'stock.shelf': 'Shelf at {branch}',
  'stock.item': 'Item',
  'stock.onShelf': 'On the shelf',
  'stock.lowAt': 'Low at',
  'stock.low': 'Low',
  'stock.negative': 'Recount',
  'stock.delivery': 'Delivery',
  'stock.count': 'Count',
  'stock.writeOff': 'Write off',
  'stock.threshold': 'Low-stock level',
  'stock.deliveryOf': 'Delivery of {name}',
  'stock.countOf': 'Count {name}',
  'stock.writeOffOf': 'Write off {name}',
  'stock.thresholdOf': 'Low-stock level for {name}',
  'stock.received': 'How many arrived',
  'stock.counted': 'How many are there',
  'stock.gone': 'How many are gone',
  'stock.writeOffReason': 'Why',
  'stock.writeOffReasonPick': 'Choose a reason',
  'stock.writeOffNote': 'Note (optional)',
  'stock.writeOffNoteRequired': 'What happened',
  'stock.countHint': 'The shelf says {quantity}. Enter what is really there; the difference is recorded.',
  'stock.thresholdHint': 'Shown as low at or below this number at this branch. Leave empty for “out of stock” only.',
  'stock.saved': 'Stock saved',
  'stock.movements': 'Movements',
  'stock.noMovements': 'No movements yet.',
  'stock.change': 'Change',
  'stock.after': 'After',
  'stock.left.one': '{count} left',
  'stock.left.other': '{count} left',
  'stock.restock': 'Put counted items back on the shelf',
  'stock.restockHint': 'Leave on for something unopened; switch off for something spilled or opened.',
  'menuBar.countStock': 'Count stock',
  'menuBar.countStockHint': 'Each branch counts how many it has; sales take it down.',
  'menuBar.barcode': 'Barcode',
  'menuBar.barcodeHint': "Scan the package or type the number. Shown on the Stock page so it can be scanned from the screen.",
  'menuBar.barcodeTaken': 'Another item already has this barcode',
  'bar.scanned': 'Added {name}',
  'bar.unknownBarcode': 'No item on the menu has barcode {code}',
  'menuBar.counted': 'Stock counted',
  'enum.stockMovementKind.SALE': 'Sale',
  'enum.stockMovementKind.REFUND': 'Refund',
  'enum.stockMovementKind.DELIVERY': 'Delivery',
  'enum.stockMovementKind.COUNT': 'Count',
  'enum.stockMovementKind.WRITE_OFF': 'Write-off',
  'menuBar.sellable': 'Sold at the bar',
  'menuBar.sellableHint': 'The bar can ring it up. Independent of whether the website shows it.',
  'menuBar.notSold': 'Not sold at the bar',
  'enum.barPaymentMethod.WALLET': 'Balance',
  'enum.barPaymentMethod.CASH': 'Cash',
  'enum.barPaymentMethod.CARD_TERMINAL': 'Card',
  'enum.barSaleStatus.COMPLETED': 'Completed',
  'enum.barSaleStatus.PARTIALLY_REFUNDED': 'Partly refunded',
  'enum.barSaleStatus.REFUNDED': 'Refunded',
  'shell.nav.barReport': 'Bar sales',
  'barReport.title': 'Bar sales',
  'barReport.description': 'What the bar sold and refunded, by what paid for it, where and by whom.',
  'barReport.atBranch': 'At {branch}',
  'barReport.sales': 'Sales',
  'barReport.saleCount': 'Receipts',
  'barReport.itemsSold.one': '{count} item sold',
  'barReport.itemsSold.other': '{count} items sold',
  'barReport.emptyTitle': 'Nothing sold in this period',
  'barReport.emptyDescription': 'Sales and refunds at the bar show here once the till is used.',
  'barReport.byBranch': 'By branch',
  'barReport.byCategory': 'By category',
  'barReport.byProduct': 'By product',
  'barReport.byDay': 'By day',
  'barReport.quantity': 'Quantity',
  'barReport.offMenu': 'Removed from the menu',
  'barReport.balanceTitle': 'Balances',
  'barReport.balanceHint': 'Money members paid in advance. It stays theirs until they spend it, so it is not bar revenue.',
  'barReport.topUps': 'Topped up in the period',
  'barReport.held': 'Held for members at the end',
  'barReport.heldHint': 'Across every branch: one balance works everywhere.',
  'barReport.view.sales': 'Sales',
  'barReport.view.profit': 'Profitability',
  'barProfit.withoutVat': 'Amounts are without VAT ({rate}%).',
  'barProfit.noVat': 'The gym does not charge VAT (Settings → Sales), so amounts are the prices paid.',
  'barProfit.method': 'Costs are moving averages per branch: each costed delivery blends into what is on the shelf, and every sale keeps the cost it was sold at.',
  'barProfit.netSales': 'Net sales',
  'barProfit.grossProfit': 'Gross profit',
  'barProfit.margin': 'Margin',
  'barProfit.marginHint': 'Gross profit ÷ sales that have a cost',
  'barProfit.barCost': 'Bar cost',
  'barProfit.barCostHint': 'Cost of goods ÷ sales that have a cost',
  'barProfit.stockAtCost': 'Stock at cost',
  'barProfit.stockAtRetail': 'Stock at retail',
  'barProfit.potentialProfit': 'Potential profit on stock',
  'barProfit.uncostedUnits': '{count} unit(s) on the shelves have no cost yet',
  'barProfit.gmroi': 'GMROI',
  'barProfit.gmroiHint': "The period's gross profit per unit of money held in stock at cost now",
  'barProfit.bridge': 'From sales to gross profit',
  'barProfit.bridgeHint': 'Lines sold in the period, less what was refunded from them.',
  'barProfit.step.gross': 'Gross sales',
  'barProfit.step.refunds': 'Refunds',
  'barProfit.step.vat': 'VAT ({rate}%)',
  'barProfit.step.uncosted': 'Sales without a cost',
  'barProfit.step.cogs': 'Cost of goods',
  'barProfit.step.writeOffs': 'Write-offs',
  'barProfit.step.profit': 'Gross profit',
  'barProfit.byCategory': 'Margin by category',
  'barProfit.byItem': 'Margin by item',
  'barProfit.category': 'Category',
  'barProfit.item': 'Item',
  'barProfit.units': 'Units',
  'barProfit.cost': 'Cost',
  'barProfit.unitMargin': 'Margin per unit',
  'barProfit.class': 'Class',
  'barProfit.noCost': 'No cost yet',
  'barProfit.popularity': 'Share of units',
  'barProfit.matrix': 'Menu engineering: {category}',
  'barProfit.matrixHint': 'Each dot is an item. The dashed lines are 70% of an even share of units and the average margin per unit.',
  'barProfit.matrixAria': 'Items by share of units and margin per unit',
  'barProfit.quadrant.STAR': 'Star',
  'barProfit.quadrant.PLOWHORSE': 'Plowhorse',
  'barProfit.quadrant.PUZZLE': 'Puzzle',
  'barProfit.quadrant.DOG': 'Dog',
  'barProfit.quadrantHint.STAR': 'Popular and profitable: keep them visible.',
  'barProfit.quadrantHint.PLOWHORSE': 'Popular, thin margin: look at the price or the cost.',
  'barProfit.quadrantHint.PUZZLE': 'Profitable, rarely bought: show or suggest them more.',
  'barProfit.quadrantHint.DOG': 'Neither: consider replacing them.',
  'barReport.view.losses': 'Losses',
  'barLosses.intro': 'Stock that went without a sale and cash that did not match, valued at the average cost when it went and at today’s price.',
  'barLosses.shrinkAtPrice': 'Shrink at price',
  'barLosses.shrinkAtCost': 'Shrink at cost',
  'barLosses.atCost': 'At cost: {amount}',
  'barLosses.shrinkPct': 'Shrink % of sales',
  'barLosses.shrinkPctHint': 'Shrink at price ÷ bar sales less refunds',
  'barLosses.countLoss': 'Units missing at counts',
  'barLosses.countLossHint': 'Net of units found extra, over {count} count(s)',
  'barLosses.cash': 'Bar cash over or short',
  'barLosses.cashHint': 'Over {over} · short {short}',
  'barLosses.uncosted': '{count} lost unit(s) have no cost on record and are valued at price only.',
  'barLosses.emptyTitle': 'Nothing went missing',
  'barLosses.emptyDescription': 'No count differences, write-offs, unreturned refunds or bar shifts in this period.',
  'barLosses.byItem': 'Count differences',
  'barLosses.byItemHint': 'What each count found against what the system expected: missing to the left, extra to the right.',
  'barLosses.noCountDifferences': 'Every count matched.',
  'barLosses.byReason': 'Write-offs by reason',
  'barLosses.noWriteOffs': 'Nothing was written off.',
  'barLosses.unspecified': 'No reason recorded',
  'barLosses.items': 'Losses by item',
  'barLosses.countDifference': 'Count difference',
  'barLosses.writtenOff': 'Written off',
  'barLosses.unrestocked': 'Refunded, not put back',
  'barLosses.staff': 'Refunds by person',
  'barLosses.staffHint': 'Refunds a person made ÷ sales they made. Team median {median}; more than twice that with two refunds or more is flagged.',
  'barLosses.person': 'Person',
  'barLosses.rate': 'Refund rate',
  'barLosses.flagged': 'Check',
  'barLosses.ownSales': '{count} refund(s) of their own sales',
  'barLosses.inCash': '{amount} in cash',
  'barLosses.shifts': 'Bar shifts',
  'barLosses.noShifts': 'No bar shift closed in this period.',
  'barLosses.closed': 'Closed',
  'barLosses.expected': 'Expected',
  'barLosses.counted': 'Counted',
  'barLosses.difference': 'Difference',
  'barReport.dailyTitle': 'Bar',
  'barReport.dailyHint': 'Sales and refunds at the bar, by what paid for them. A balance sale spends money already taken as a top-up.',
  'barReport.dailyEmpty': 'Nothing sold at the bar this day.',
  'stock.stat.items': 'Items counted',
  'stock.everyBranch': 'Every branch',
  'stock.stat.attention': 'Need attention',
  'stock.stat.attentionHint': 'Low, out, or to recount',
  'stock.stat.valueAtCost': 'Stock at cost',
  'stock.stat.missingCost': '{count} with no cost yet',
  'stock.stat.valueAtPrice': 'Stock at sale price',
  'stock.everyShelf': 'Every branch\'s shelf',
  'stock.pickBranchToChange': 'Pick a branch in the sidebar to record deliveries, counts and write-offs.',
  'stock.search': 'Search stock',
  'stock.searchPlaceholder': 'Name, category or barcode',
  'stock.filter.category': 'Category',
  'stock.filter.everyCategory': 'Every category',
  'stock.filter.status': 'Status',
  'stock.filter.everyStatus': 'Every status',
  'stock.filter.attention': 'Needs attention',
  'stock.filter.barcode': 'Barcode',
  'stock.filter.anyBarcode': 'With or without a barcode',
  'stock.filter.withBarcode': 'With a barcode',
  'stock.filter.withoutBarcode': 'Without a barcode',
  'stock.status.OK': 'OK',
  'stock.status.LOW': 'Low',
  'stock.status.OUT': 'Out',
  'stock.status.NEGATIVE': 'Recount',
  'stock.scanHint': 'Scan a barcode anywhere on this page to find its item.',
  'stock.noMatch': 'No item matches the search and filters.',
  'stock.col.barcode': 'Barcode',
  'stock.col.price': 'Sale price',
  'stock.col.cost': 'Last cost',
  'stock.col.value': 'Value',
  'stock.col.sold': 'Sold, 30 days',
  'stock.col.cover': 'Lasts',
  'stock.col.delivered': 'Delivered',
  'stock.col.counted': 'Counted',
  'stock.col.lastSale': 'Last sold',
  'stock.atSalePrice': 'at sale price',
  'stock.days': '{count} d',
  'stock.unitCostShort': 'cost {cost}',
  'stock.unitCost': 'Cost of one ({currency})',
  'stock.unitCostLast': 'Last time {cost}',
  'stock.unitCostInvalid': 'Enter an amount, or leave it empty',
  'barcode.enlarge': 'Show larger to scan',
  'barcode.enlargeOf': 'Show barcode {value} larger',
  'barcode.scanHint': 'Hold the scanner or a phone camera up to the screen.',
  'product.back': 'All stock',
  'product.otherNames': 'Also called',
  'product.notSold': 'Not sold at the bar',
  'product.shelves': 'Shelves',
  'product.prices': 'Price history',
  'product.col.from': 'From',
  'product.col.change': 'Change',
  'product.col.by': 'Changed by',
  'product.charts': 'Sales and stock',
  'product.lastDays': 'Last {count} days',
  'product.kpi.sold': 'Sold',
  'product.kpi.refunded': '{count} refunded',
  'product.kpi.perDay': '{value} a day',
  'product.kpi.takings': 'Takings',
  'product.kpi.received': 'Received',
  'product.kpi.sellThrough': '{value} of it sold',
  'product.kpi.losses': 'Lost',
  'product.kpi.lossesHint': 'Written off {writtenOff}, count difference {counted}',
  'product.kpi.margin': 'Margin per unit',
  'product.kpi.marginHint': 'The sale price less the last cost',
  'product.series.sold': 'Sold',
  'product.series.received': 'Received',
  'product.series.shelf': 'On the shelves',
  'product.series.price': 'Sale price',
  'product.series.cost': 'Last cost',
  'product.chart.flow': 'Received and sold',
  'product.chart.sold': 'Sold',
  'product.chart.shelf': 'On the shelves at the end of each day',
  'product.chart.price': 'Sale price',
  'product.chart.priceAndCost': 'Sale price and cost',
  'product.chart.hours': 'Sold by hour of day',
  'product.chart.heatmap': 'Sold by weekday and hour',
  'product.hour': '{from}:00–{to}:00',
  'product.heat.sold': 'Units sold',
};

export const ka: Record<keyof typeof en, string> = {
  'shell.nav.bar': 'ბარი',
  'bar.title': 'ბარი',
  'bar.description': 'შეკვეთის შესადგენად დააჭირეთ პროდუქტებს, შემდეგ ჩამოჭერით ბალანსიდან ბარათის მიდებით, ან მიიღეთ ნაღდი ან ბარათით გადახდა.',
  'bar.pickBranch': 'გასაყიდად გვერდით მენიუში აირჩიეთ ფილიალი, სადაც მუშაობთ.',
  'bar.emptyMenu': 'გასაყიდი ჯერ არაფერია',
  'bar.emptyMenuHint': 'დაამატეთ პროდუქტები მენიუში და მონიშნეთ „იყიდება ბარში“.',
  'bar.all': 'ყველა',
  'bar.order': 'შეკვეთა',
  'bar.emptyOrder': 'დასამატებლად დააჭირეთ პროდუქტს.',
  'bar.total': 'სულ',
  'bar.clear': 'გასუფთავება',
  'bar.increase': 'კიდევ ერთი {name}',
  'bar.decrease': 'ერთით ნაკლები {name}',
  'bar.chargeBalance': 'ბალანსიდან',
  'bar.cash': 'ნაღდი',
  'bar.card': 'ბარათი',
  'bar.tapTitle': '{amount}-ის ჩამოჭრა ბალანსიდან',
  'bar.tapHint': 'სთხოვეთ წევრს ბარათის მიდება წამკითხველზე, ან აკრიფეთ ბარათის ნომერი.',
  'bar.cardNumber': 'ბარათის ნომერი',
  'bar.findCard': 'მოძებნა',
  'bar.cardUnknown': 'ეს ბარათი არცერთ წევრს არ ეკუთვნის.',
  'bar.balanceNow': 'ბალანსი {amount}',
  'bar.afterSale': 'ამ გაყიდვის შემდეგ: {amount}',
  'bar.shortBy': 'აკლია {amount}. შეავსეთ მიმღებთან, ან მიიღეთ ნაღდი ან ბარათით.',
  'bar.confirmCharge': '{amount}-ის ჩამოჭრა',
  'bar.otherCard': 'სხვა ბარათი',
  'bar.payTitle': '{amount} — {method}',
  'bar.payHint': 'ჯერ მიიღეთ თანხა, შემდეგ დაადასტურეთ. წევრის ბარათის მიდება არასავალდებულოა: გაყიდვა მის ისტორიაში აისახება.',
  'bar.confirmPaid': 'გადახდილია',
  'bar.sold': 'გაიყიდა · {receipt}',
  'bar.soldBalance': 'გაიყიდა · {receipt} · ბალანსი ახლა {amount}',
  'bar.priceChanged': 'ფასი შეიცვალა და შეკვეთა განახლდა. გადაამოწმეთ ჯამი და სცადეთ ხელახლა.',
  'bar.todaySales': 'დღევანდელი გაყიდვები',
  'bar.noSales': 'დღეს ჯერ არაფერი გაყიდულა.',
  'bar.walkIn': 'სტუმარი',
  'bar.saleTitle': 'გაყიდვა {receipt}',
  'bar.soldBy': 'გაყიდა: {name}',
  'bar.qty': '{count} ×',
  'barRefund.action': 'დაბრუნება',
  'barRefund.title': '{receipt} — დაბრუნება',
  'barRefund.hint': 'აირჩიეთ, რა ბრუნდება. თანხა ბრუნდება ისე ({method}), როგორც გადაიხადეს.',
  'barRefund.tapHint': 'სთხოვეთ გადამხდელ წევრს ბარათის ხელახლა მიდება; თანხა მის ბალანსზე დაბრუნდება.',
  'barRefund.back': 'უკან',
  'barRefund.confirm': '{amount}-ის დაბრუნება',
  'barRefund.reason': 'მიზეზი',
  'barRefund.left.one': 'დასაბრუნებელია {count}, თითო {amount}',
  'barRefund.left.other': 'დასაბრუნებელია {count}, თითო {amount}',
  'barRefund.allBack': 'უკვე დაბრუნებულია',
  'barRefund.mismatch': 'ეს ბარათი გადამხდელ წევრს არ ეკუთვნის.',
  'barRefund.done': 'დაბრუნდა {amount}',
  'barRefund.doneBalance': 'ბალანსზე დაბრუნდა {amount}, ახლა {balance}',
  'barRefund.lineBack': 'დაბრუნდა {count}',
  'barRefund.history': 'დაბრუნებები',
  'shell.nav.barStock': 'მარაგი',
  'shell.nav.barInsights': 'ანალიტიკა',
  'menuBar.leadTime': 'მიწოდების ვადა, დღე',
  'menuBar.leadTimeHint': 'შეკვეთიდან მიწოდებამდე. ბარი → ანალიტიკა შეკვეთას სთავაზობს მხოლოდ ვადის მქონე პროდუქტებზე.',
  'menuBar.packSize': 'შეფუთვის ზომა',
  'menuBar.packSizeHint': 'ერთეული ყუთში; შემოთავაზებული შეკვეთა მრგვალდება მთელ ყუთებამდე.',
  'barInsights.title': 'ბარის ანალიტიკა',
  'barInsights.description': 'რომელი პროდუქტი მოაქვს შემოსავალს, რომელი დევს თაროზე, როდის არის ბარი დატვირთული, როდის დაიცალა თაროები და რა შევუკვეთოთ.',
  'barInsights.slowLine': 'ნელი',
  'barInsights.slowAfter': 'ნელი {days} დღის შემდეგ',
  'barInsights.gradeA': 'A პროდუქტები',
  'barInsights.gradeAHint': '{count} გაყიდული პროდუქტიდან',
  'barInsights.slowStock': 'ნელი პროდუქტები თაროზე',
  'barInsights.stockoutDays': 'დღეები ცარიელი თაროთი',
  'barInsights.lostSales': 'დაახლოებით {amount} გაუყიდავი',
  'barInsights.toOrder': 'შესაკვეთი პროდუქტები',
  'barInsights.toOrderHint': 'მიწოდების ვადით და თაროზე არასაკმარისი რაოდენობით',
  'barInsights.abc': 'ABC შემოსავლის მიხედვით',
  'barInsights.abcHint': 'A: პროდუქტები, რომლებსაც შემოსავლის პირველი 80% მოაქვს, B: შემდეგი 15%, C: დანარჩენი. თითოეულ ხაზზე ჩანს დაგროვილი წილი.',
  'barInsights.aging': 'დღეები ბოლო გაყიდვიდან',
  'barInsights.agingHint': 'მენიუს ყველა პროდუქტი; ნელია, თუ {days} დღეზე მეტია არ გაყიდულა.',
  'barInsights.bucketDays': '{range} დღე',
  'barInsights.never': 'არასდროს გაყიდულა',
  'barInsights.daysSince': 'დღე გაყიდვიდან',
  'barInsights.onHand': 'თაროზე',
  'barInsights.noSlowStock': 'თაროზე ნელი პროდუქტი არ არის.',
  'barInsights.heatmap': 'როდის არის ბარი დატვირთული',
  'barInsights.heatmapHint': 'ჩეკები საათში, პერიოდის თითოეული კვირის დღის საშუალოთი. წერტილით მონიშნული უჯრა ყველაზე დატვირთულია.',
  'barInsights.heat.average': 'ამ კვირის დღის საშუალო პერიოდში',
  'barInsights.heat.busiest': 'ყველაზე დატვირთული საათი',
  'barInsights.heat.receipts': 'ჩეკები',
  'barInsights.heat.units': 'ერთეული',
  'barInsights.heat.takings': 'შემოსავალი',
  'barHeat.read': '{label}. უჯრის სანახავად მიიტანეთ მასზე კურსორი ან გამოიყენეთ ისრიანი ღილაკები.',
  'barHeat.less': 'ნაკლები',
  'barHeat.more': 'მეტი',
  'barInsights.noSales': 'ამ პერიოდში გაყიდვები არ არის.',
  'barInsights.stockouts': 'ცარიელი თაროები',
  'barInsights.stockoutsHint': 'დღეები, როცა აღრიცხული პროდუქტი თაროზე აღარ იყო, და რამდენს ყიდის ჩვეულებრივ ამ კვირის დღეებში.',
  'barInsights.stockoutLine': '{days} დღე · დაახლოებით {units} ერთეული, {amount}',
  'barInsights.noStockouts': 'ამ პერიოდში აღრიცხული პროდუქტი არ გათავებულა.',
  'barInsights.order': 'შემოთავაზებული შეკვეთა',
  'barInsights.orderHint': 'საკმარისი მიწოდების ვადისა და შემდეგი {days} დღისთვის, დღიური გაყიდვების გლუვი საშუალოთი, დამატებით სადაზღვევო მარაგით, თაროზე არსებულის გამოკლებით, მთელ ყუთებში.',
  'barInsights.noCounted': 'ამ პერიოდში აღრიცხული პროდუქტი არ გაყიდულა.',
  'barInsights.branch': 'ფილიალი',
  'barInsights.perDay': 'დღეში',
  'barInsights.leadTime': 'მიწოდების ვადა',
  'barInsights.safety': 'სადაზღვევო მარაგი',
  'barInsights.suggested': 'შეკვეთა',
  'barInsights.setLeadTime': 'მიუთითეთ მიწოდების ვადა',
  'barInsights.packs': '{count} ყუთი, თითო {size}',
  'barInsights.view.items': 'პროდუქტები',
  'barInsights.view.members': 'წევრები',
  'barMembers.intro': 'აქ ითვლება მხოლოდ წევრზე მიბმული გაყიდვები: ბალანსით გადახდილი და ბარათის მიდებით შესრულებული ({share} ამ პერიოდის ბარის გაყიდვებიდან).',
  'barMembers.dormantLine': 'უმოქმედო',
  'barMembers.dormantAfter': 'ბალანსი უმოქმედოა {days} დღის შემდეგ',
  'barMembers.penetration': 'მომსვლელები, ვინც ყიდულობს',
  'barMembers.penetrationHint': 'წევრ-დღეები ვიზიტითა და ბარის ჩეკით ÷ წევრ-დღეები ვიზიტით',
  'barMembers.buyingMembers': 'წევრები, ვინც იყიდა',
  'barMembers.ofVisitors': '{count} მოსულიდან',
  'barMembers.spendPerBuyer': 'ხარჯი მყიდველზე',
  'barMembers.receiptsPerBuyer': 'ჩეკი მყიდველზე',
  'barMembers.byDay': 'მომსვლელები, ვინც ყიდულობს, დღეების მიხედვით',
  'barMembers.visitors': 'მოვიდა',
  'barMembers.buyers': 'იყიდა',
  'barMembers.frequency': 'რამდენად ხშირად ყიდულობენ',
  'barMembers.receipts': '{range} ჩეკი',
  'barMembers.recency': 'როდის იყიდეს ბოლოს',
  'barMembers.daysAgo': '{range} დღის წინ',
  'barMembers.cohorts': 'ბრუნდებიან თუ არა პირველად მყიდველები?',
  'barMembers.cohortsHint': 'წევრები დაჯგუფებულია ბარში პირველი შეძენის თვის მიხედვით; თითოეული უჯრა არის წილი, ვინც ამდენი თვის შემდეგ ისევ იყიდა.',
  'barMembers.firstBought': 'პირველად იყიდა',
  'barMembers.noBuyers': 'ბარში ჯერ არცერთ წევრს უყიდია.',
  'barMembers.byPlan': 'აბონემენტის მიხედვით',
  'barMembers.byAge': 'ასაკის მიხედვით',
  'barMembers.byGender': 'სქესის მიხედვით',
  'barMembers.group': 'ჯგუფი',
  'barMembers.noPlan': 'აქტიური აბონემენტის გარეშე',
  'barMembers.ageUnknown': 'ასაკი უცნობია',
  'barMembers.under18': '18 წლამდე',
  'barMembers.tooFew': 'ჯერ არცერთ ჯგუფს არ ჰყავს {size} ან მეტი მყიდველი.',
  'barMembers.hidden': '{count} ჯგუფი {size}-ზე ნაკლები მყიდველით გამოტოვებულია, რომ ვინმე არ გამოირჩეოდეს.',
  'barMembers.dormant': '{days} დღე ხელუხლებელი ბალანსები',
  'barMembers.dormantHint': '{count} წევრს აქვს {amount}, რომელიც არ შეუვსია და არ დაუხარჯავს. ყველა ფილიალში.',
  'barMembers.noDormant': 'უმოქმედო ბალანსი არ არის.',
  'barMembers.member': 'წევრი',
  'barMembers.balance': 'ბალანსი',
  'barMembers.lastMovement': 'ბოლო მოძრაობა',
  'stock.title': 'მარაგი',
  'stock.description': 'რა აქვს თითოეულ ფილიალს თაროზე, რა ღირდა და რამდენად სწრაფად იყიდება. გაყიდვა ამცირებს, მიწოდება და აღწერა ასწორებს.',
  'stock.empty': 'ჯერ არაფერი ითვლება',
  'stock.emptyHint': 'მენიუს რედაქტორში ჩართეთ „მარაგის აღრიცხვა“ პროდუქტისთვის.',
  'stock.shelf': 'თარო: {branch}',
  'stock.item': 'პროდუქტი',
  'stock.onShelf': 'თაროზე',
  'stock.lowAt': 'მცირე მარაგი',
  'stock.low': 'მცირეა',
  'stock.negative': 'გადათვალეთ',
  'stock.delivery': 'მიწოდება',
  'stock.count': 'აღწერა',
  'stock.writeOff': 'ჩამოწერა',
  'stock.threshold': 'მცირე მარაგის ზღვარი',
  'stock.deliveryOf': 'მიწოდება: {name}',
  'stock.countOf': 'აღწერა: {name}',
  'stock.writeOffOf': 'ჩამოწერა: {name}',
  'stock.thresholdOf': 'მცირე მარაგის ზღვარი: {name}',
  'stock.received': 'რამდენი მოვიდა',
  'stock.counted': 'რამდენია სინამდვილეში',
  'stock.gone': 'რამდენი დაიკარგა',
  'stock.writeOffReason': 'მიზეზი',
  'stock.writeOffReasonPick': 'აირჩიეთ მიზეზი',
  'stock.writeOffNote': 'შენიშვნა (არასავალდებულო)',
  'stock.writeOffNoteRequired': 'რა მოხდა',
  'stock.countHint': 'სისტემაში არის {quantity}. შეიყვანეთ რეალური რაოდენობა; სხვაობა აღირიცხება.',
  'stock.thresholdHint': 'ამ რაოდენობაზე ან ნაკლებზე ამ ფილიალში მცირედ ჩაითვლება. დატოვეთ ცარიელი, თუ მხოლოდ ამოწურვა გაინტერესებთ.',
  'stock.saved': 'მარაგი შენახულია',
  'stock.movements': 'მოძრაობა',
  'stock.noMovements': 'მოძრაობა ჯერ არ ყოფილა.',
  'stock.change': 'ცვლილება',
  'stock.after': 'შემდეგ',
  'stock.left.one': 'დარჩა {count}',
  'stock.left.other': 'დარჩა {count}',
  'stock.restock': 'აღრიცხული პროდუქტის თაროზე დაბრუნება',
  'stock.restockHint': 'დატოვეთ ჩართული გაუხსნელისთვის; გამორთეთ დაღვრილის ან გახსნილისთვის.',
  'menuBar.countStock': 'მარაგის აღრიცხვა',
  'menuBar.countStockHint': 'თითოეული ფილიალი ითვლის რამდენი აქვს; გაყიდვა ამცირებს.',
  'menuBar.barcode': 'შტრიხკოდი',
  'menuBar.barcodeHint': 'დაასკანერეთ შეფუთვა ან აკრიფეთ ნომერი. ჩანს მარაგის გვერდზე, რომ ეკრანიდან დასკანერდეს.',
  'menuBar.barcodeTaken': 'ეს შტრიხკოდი სხვა პროდუქტს უკვე აქვს',
  'bar.scanned': 'დაემატა: {name}',
  'bar.unknownBarcode': 'მენიუში შტრიხკოდით {code} პროდუქტი არ არის',
  'menuBar.counted': 'მარაგი ითვლება',
  'enum.stockMovementKind.SALE': 'გაყიდვა',
  'enum.stockMovementKind.REFUND': 'დაბრუნება',
  'enum.stockMovementKind.DELIVERY': 'მიწოდება',
  'enum.stockMovementKind.COUNT': 'აღწერა',
  'enum.stockMovementKind.WRITE_OFF': 'ჩამოწერა',
  'menuBar.sellable': 'იყიდება ბარში',
  'menuBar.sellableHint': 'ბარს შეუძლია მისი გაყიდვა. არ არის დამოკიდებული იმაზე, ჩანს თუ არა ვებსაიტზე.',
  'menuBar.notSold': 'ბარში არ იყიდება',
  'enum.barPaymentMethod.WALLET': 'ბალანსი',
  'enum.barPaymentMethod.CASH': 'ნაღდი',
  'enum.barPaymentMethod.CARD_TERMINAL': 'ბარათი',
  'enum.barSaleStatus.COMPLETED': 'დასრულებული',
  'enum.barSaleStatus.PARTIALLY_REFUNDED': 'ნაწილობრივ დაბრუნებული',
  'enum.barSaleStatus.REFUNDED': 'დაბრუნებული',
  'shell.nav.barReport': 'ბარის გაყიდვები',
  'barReport.title': 'ბარის გაყიდვები',
  'barReport.description': 'რა გაიყიდა და დაბრუნდა ბარში, რით გადაიხადეს, სად და ვინ გაყიდა.',
  'barReport.atBranch': 'ფილიალი: {branch}',
  'barReport.sales': 'გაყიდვები',
  'barReport.saleCount': 'ჩეკები',
  'barReport.itemsSold.one': 'გაიყიდა {count} ერთეული',
  'barReport.itemsSold.other': 'გაიყიდა {count} ერთეული',
  'barReport.emptyTitle': 'ამ პერიოდში არაფერი გაყიდულა',
  'barReport.emptyDescription': 'ბარის გაყიდვები და დაბრუნებები აქ გამოჩნდება, როცა სალარო ამუშავდება.',
  'barReport.byBranch': 'ფილიალების მიხედვით',
  'barReport.byCategory': 'კატეგორიების მიხედვით',
  'barReport.byProduct': 'პროდუქტების მიხედვით',
  'barReport.byDay': 'დღეების მიხედვით',
  'barReport.quantity': 'რაოდენობა',
  'barReport.offMenu': 'მენიუდან ამოღებული',
  'barReport.balanceTitle': 'ბალანსები',
  'barReport.balanceHint': 'წინასწარ გადახდილი თანხა. წევრს ეკუთვნის, სანამ არ დახარჯავს, ამიტომ ბარის შემოსავალი არ არის.',
  'barReport.topUps': 'შევსებული პერიოდში',
  'barReport.held': 'წევრების ბალანსზე პერიოდის ბოლოს',
  'barReport.heldHint': 'ყველა ფილიალში: ერთი ბალანსი ყველგან მუშაობს.',
  'barReport.view.sales': 'გაყიდვები',
  'barReport.view.profit': 'მომგებიანობა',
  'barProfit.withoutVat': 'თანხები მოცემულია დღგ-ის ({rate}%) გარეშე.',
  'barProfit.noVat': 'დარბაზი დღგ-ს არ იხდის (პარამეტრები → გაყიდვები), ამიტომ თანხები გადახდილი ფასებია.',
  'barProfit.method': 'თვითღირებულება მცოცავი საშუალოა ფილიალის მიხედვით: თითოეული მიწოდება ფასით ერწყმის თაროზე არსებულს, ყოველი გაყიდვა კი ინახავს იმ თვითღირებულებას, რომლითაც გაიყიდა.',
  'barProfit.netSales': 'წმინდა გაყიდვები',
  'barProfit.grossProfit': 'მთლიანი მოგება',
  'barProfit.margin': 'მარჟა',
  'barProfit.marginHint': 'მთლიანი მოგება ÷ თვითღირებულების მქონე გაყიდვები',
  'barProfit.barCost': 'ბარის ხარჯი',
  'barProfit.barCostHint': 'საქონლის თვითღირებულება ÷ თვითღირებულების მქონე გაყიდვები',
  'barProfit.stockAtCost': 'მარაგი თვითღირებულებით',
  'barProfit.stockAtRetail': 'მარაგი გასაყიდი ფასით',
  'barProfit.potentialProfit': 'პოტენციური მოგება მარაგზე',
  'barProfit.uncostedUnits': 'თაროზე {count} ერთეულს ჯერ არ აქვს თვითღირებულება',
  'barProfit.gmroi': 'GMROI',
  'barProfit.gmroiHint': 'პერიოდის მთლიანი მოგება მარაგში ახლა თვითღირებულებით ჩადებულ ყოველ ერთეულ თანხაზე',
  'barProfit.bridge': 'გაყიდვებიდან მთლიან მოგებამდე',
  'barProfit.bridgeHint': 'პერიოდში გაყიდული ხაზები, მათგან დაბრუნებულის გამოკლებით.',
  'barProfit.step.gross': 'მთლიანი გაყიდვები',
  'barProfit.step.refunds': 'დაბრუნებები',
  'barProfit.step.vat': 'დღგ ({rate}%)',
  'barProfit.step.uncosted': 'გაყიდვები თვითღირებულების გარეშე',
  'barProfit.step.cogs': 'საქონლის თვითღირებულება',
  'barProfit.step.writeOffs': 'ჩამოწერები',
  'barProfit.step.profit': 'მთლიანი მოგება',
  'barProfit.byCategory': 'მარჟა კატეგორიების მიხედვით',
  'barProfit.byItem': 'მარჟა პროდუქტების მიხედვით',
  'barProfit.category': 'კატეგორია',
  'barProfit.item': 'პროდუქტი',
  'barProfit.units': 'ერთეული',
  'barProfit.cost': 'თვითღირებულება',
  'barProfit.unitMargin': 'მარჟა ერთეულზე',
  'barProfit.class': 'კლასი',
  'barProfit.noCost': 'თვითღირებულება ჯერ არ არის',
  'barProfit.popularity': 'ერთეულების წილი',
  'barProfit.matrix': 'მენიუს ანალიზი: {category}',
  'barProfit.matrixHint': 'თითოეული წერტილი პროდუქტია. წყვეტილი ხაზები: ერთეულების თანაბარი წილის 70% და საშუალო მარჟა ერთეულზე.',
  'barProfit.matrixAria': 'პროდუქტები ერთეულების წილისა და ერთეულზე მარჟის მიხედვით',
  'barProfit.quadrant.STAR': 'ვარსკვლავი',
  'barProfit.quadrant.PLOWHORSE': 'მუშა ცხენი',
  'barProfit.quadrant.PUZZLE': 'თავსატეხი',
  'barProfit.quadrant.DOG': 'სუსტი',
  'barProfit.quadrantHint.STAR': 'პოპულარული და მომგებიანი: შეინარჩუნეთ თვალსაჩინოდ.',
  'barProfit.quadrantHint.PLOWHORSE': 'პოპულარული, მცირე მარჟით: გადახედეთ ფასს ან თვითღირებულებას.',
  'barProfit.quadrantHint.PUZZLE': 'მომგებიანი, იშვიათად ყიდულობენ: უფრო ხშირად შესთავაზეთ.',
  'barProfit.quadrantHint.DOG': 'არც ერთი: განიხილეთ ჩანაცვლება.',
  'barReport.view.losses': 'დანაკარგები',
  'barLosses.intro': 'მარაგი, რომელიც გაყიდვის გარეშე წავიდა, და ნაღდი ფული, რომელიც არ დაემთხვა; შეფასებულია საშუალო თვითღირებულებით და დღევანდელი ფასით.',
  'barLosses.shrinkAtPrice': 'დანაკარგი ფასით',
  'barLosses.shrinkAtCost': 'დანაკარგი თვითღირებულებით',
  'barLosses.atCost': 'თვითღირებულებით: {amount}',
  'barLosses.shrinkPct': 'დანაკარგი გაყიდვების %',
  'barLosses.shrinkPctHint': 'დანაკარგი ფასით ÷ ბარის გაყიდვები დაბრუნებების გამოკლებით',
  'barLosses.countLoss': 'ინვენტარიზაციისას დაკარგული ერთეული',
  'barLosses.countLossHint': 'ზედმეტად ნაპოვნის გამოკლებით, {count} ინვენტარიზაციაში',
  'barLosses.cash': 'ბარის ნაღდის ზედმეტობა ან დანაკლისი',
  'barLosses.cashHint': 'ზედმეტი {over} · დანაკლისი {short}',
  'barLosses.uncosted': 'დაკარგულ {count} ერთეულს თვითღირებულება არ აქვს და შეფასებულია მხოლოდ ფასით.',
  'barLosses.emptyTitle': 'არაფერი დაკარგულა',
  'barLosses.emptyDescription': 'ამ პერიოდში არ ყოფილა ინვენტარიზაციის სხვაობა, ჩამოწერა, დაუბრუნებელი თანხის დაბრუნება ან ბარის ცვლა.',
  'barLosses.byItem': 'ინვენტარიზაციის სხვაობები',
  'barLosses.byItemHint': 'რა აჩვენა თითოეულმა ინვენტარიზაციამ სისტემასთან შედარებით: დაკარგული მარცხნივ, ზედმეტი მარჯვნივ.',
  'barLosses.noCountDifferences': 'ყველა ინვენტარიზაცია დაემთხვა.',
  'barLosses.byReason': 'ჩამოწერები მიზეზის მიხედვით',
  'barLosses.noWriteOffs': 'არაფერი ჩამოწერილა.',
  'barLosses.unspecified': 'მიზეზი არ არის მითითებული',
  'barLosses.items': 'დანაკარგები პროდუქტების მიხედვით',
  'barLosses.countDifference': 'ინვენტარიზაციის სხვაობა',
  'barLosses.writtenOff': 'ჩამოწერილი',
  'barLosses.unrestocked': 'დაბრუნებული, თაროზე არ დაბრუნებულა',
  'barLosses.staff': 'დაბრუნებები თანამშრომლების მიხედვით',
  'barLosses.staffHint': 'თანამშრომლის დაბრუნებები ÷ მისი გაყიდვები. გუნდის მედიანა {median}; ორჯერ მეტი, ორი ან მეტი დაბრუნებით, მოინიშნება.',
  'barLosses.person': 'თანამშრომელი',
  'barLosses.rate': 'დაბრუნების წილი',
  'barLosses.flagged': 'შესამოწმებელი',
  'barLosses.ownSales': '{count} საკუთარი გაყიდვის დაბრუნება',
  'barLosses.inCash': '{amount} ნაღდით',
  'barLosses.shifts': 'ბარის ცვლები',
  'barLosses.noShifts': 'ამ პერიოდში ბარის ცვლა არ დახურულა.',
  'barLosses.closed': 'დაიხურა',
  'barLosses.expected': 'მოსალოდნელი',
  'barLosses.counted': 'დათვლილი',
  'barLosses.difference': 'სხვაობა',
  'barReport.dailyTitle': 'ბარი',
  'barReport.dailyHint': 'ბარის გაყიდვები და დაბრუნებები გადახდის საშუალების მიხედვით. ბალანსით გაყიდვა უკვე მიღებულ შევსებას ხარჯავს.',
  'barReport.dailyEmpty': 'ამ დღეს ბარში არაფერი გაყიდულა.',
  'stock.stat.items': 'აღრიცხული პროდუქტი',
  'stock.everyBranch': 'ყველა ფილიალი',
  'stock.stat.attention': 'საჭიროებს ყურადღებას',
  'stock.stat.attentionHint': 'მცირე, ამოწურული ან გადასათვლელი',
  'stock.stat.valueAtCost': 'მარაგი თვითღირებულებით',
  'stock.stat.missingCost': '{count} ფასის გარეშე',
  'stock.stat.valueAtPrice': 'მარაგი გასაყიდი ფასით',
  'stock.everyShelf': 'ყველა ფილიალის თარო',
  'stock.pickBranchToChange': 'მიწოდების, აღწერისა და ჩამოწერისთვის აირჩიეთ ფილიალი გვერდით მენიუში.',
  'stock.search': 'მარაგში ძებნა',
  'stock.searchPlaceholder': 'სახელი, კატეგორია ან შტრიხკოდი',
  'stock.filter.category': 'კატეგორია',
  'stock.filter.everyCategory': 'ყველა კატეგორია',
  'stock.filter.status': 'სტატუსი',
  'stock.filter.everyStatus': 'ყველა სტატუსი',
  'stock.filter.attention': 'საჭიროებს ყურადღებას',
  'stock.filter.barcode': 'შტრიხკოდი',
  'stock.filter.anyBarcode': 'შტრიხკოდით ან მის გარეშე',
  'stock.filter.withBarcode': 'შტრიხკოდით',
  'stock.filter.withoutBarcode': 'შტრიხკოდის გარეშე',
  'stock.status.OK': 'რიგზეა',
  'stock.status.LOW': 'მცირეა',
  'stock.status.OUT': 'ამოწურულია',
  'stock.status.NEGATIVE': 'გადათვალეთ',
  'stock.scanHint': 'დაასკანერეთ შტრიხკოდი ამ გვერდზე ნებისმიერ ადგილას და პროდუქტი მოიძებნება.',
  'stock.noMatch': 'ძებნას და ფილტრებს არცერთი პროდუქტი არ შეესაბამება.',
  'stock.col.barcode': 'შტრიხკოდი',
  'stock.col.price': 'გასაყიდი ფასი',
  'stock.col.cost': 'ბოლო თვითღირებულება',
  'stock.col.value': 'ღირებულება',
  'stock.col.sold': 'გაიყიდა, 30 დღე',
  'stock.col.cover': 'ეყოფა',
  'stock.col.delivered': 'მიწოდება',
  'stock.col.counted': 'აღწერა',
  'stock.col.lastSale': 'ბოლო გაყიდვა',
  'stock.atSalePrice': 'გასაყიდი ფასით',
  'stock.days': '{count} დღე',
  'stock.unitCostShort': 'თვითღირებულება {cost}',
  'stock.unitCost': 'ერთის ფასი ({currency})',
  'stock.unitCostLast': 'წინა ჯერზე {cost}',
  'stock.unitCostInvalid': 'შეიყვანეთ თანხა ან დატოვეთ ცარიელი',
  'barcode.enlarge': 'გადიდება დასასკანერებლად',
  'barcode.enlargeOf': 'შტრიხკოდის {value} გადიდება',
  'barcode.scanHint': 'მიიტანეთ სკანერი ან ტელეფონის კამერა ეკრანთან.',
  'product.back': 'მთელი მარაგი',
  'product.otherNames': 'სხვა სახელი',
  'product.notSold': 'ბარში არ იყიდება',
  'product.shelves': 'თაროები',
  'product.prices': 'ფასის ისტორია',
  'product.col.from': 'თარიღიდან',
  'product.col.change': 'ცვლილება',
  'product.col.by': 'შეცვალა',
  'product.charts': 'გაყიდვები და მარაგი',
  'product.lastDays': 'ბოლო {count} დღე',
  'product.kpi.sold': 'გაიყიდა',
  'product.kpi.refunded': '{count} დაბრუნდა',
  'product.kpi.perDay': 'დღეში {value}',
  'product.kpi.takings': 'შემოსავალი',
  'product.kpi.received': 'მიღებულია',
  'product.kpi.sellThrough': 'გაიყიდა {value}',
  'product.kpi.losses': 'დანაკარგი',
  'product.kpi.lossesHint': 'ჩამოწერილი {writtenOff}, აღწერის სხვაობა {counted}',
  'product.kpi.margin': 'მოგება ერთეულზე',
  'product.kpi.marginHint': 'გასაყიდ ფასს გამოკლებული ბოლო თვითღირებულება',
  'product.series.sold': 'გაიყიდა',
  'product.series.received': 'მიღებულია',
  'product.series.shelf': 'თაროებზე',
  'product.series.price': 'გასაყიდი ფასი',
  'product.series.cost': 'ბოლო თვითღირებულება',
  'product.chart.flow': 'მიღებული და გაყიდული',
  'product.chart.sold': 'გაყიდული',
  'product.chart.shelf': 'თაროებზე დღის ბოლოს',
  'product.chart.price': 'გასაყიდი ფასი',
  'product.chart.priceAndCost': 'გასაყიდი ფასი და თვითღირებულება',
  'product.chart.hours': 'გაყიდვები საათების მიხედვით',
  'product.chart.heatmap': 'გაყიდვები კვირის დღისა და საათის მიხედვით',
  'product.hour': '{from}:00–{to}:00',
  'product.heat.sold': 'გაყიდული ერთეული',
};
